export default __webpack_public_path__ + "static/media/icon3.1f702ec5.svg";